import { isArray, findIndex } from 'lodash';

/**
 * @param options: [{ value: string, label: string }]
 * @param values: string[]
 * @returns [index1, index2, ...] - indices of valx, valy in options objects matching value attribute
 */

type Option = {
  label: string;
  value: string | number | null;
};

export const toValueIndexes = (options: Option[], values: (string | number)[]): number[] | undefined => {
  if (!values || !isArray(options) || options.length === 0) {
    return undefined;
  }

  const valuesArray: (string | number | null)[] = isArray(values) ? values : [values];
  if (valuesArray.length === 0) {
    return undefined;
  }

  const indexes = valuesArray
    .map(value => {
      const index = options.findIndex(option => option.value === value || (value === null && option.value === null));
      return index !== -1 ? index : null;
    })
    .filter(index => index !== null) as number[];

  return indexes.length > 0 ? indexes : undefined;
};
